const LoginImages = {
  leftContentImage: '/static/images/onevision/login-image-ov.jpg',
  bgImageColor: 'transparent',
};

export default LoginImages;
